import { render, staticRenderFns } from "./unqualified-item.vue?vue&type=template&id=06bbf74c&scoped=true"
import script from "./unqualified-item.vue?vue&type=script&lang=js"
export * from "./unqualified-item.vue?vue&type=script&lang=js"
import style0 from "./unqualified-item.vue?vue&type=style&index=0&id=06bbf74c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bbf74c",
  null
  
)

export default component.exports